import { Navigate, Outlet, Route } from "react-router-dom"
import { AppRoutes } from "@constants/AppRoutes.ts"
import { AppAuthorizedProfiles } from "@constants/AppAuthorizedProfiles.ts"

import ProtectedRoute from "@components/others/PrivateRoute/PrivateRoute.tsx"
import ChatBackOffice from "@pages/ChatBackOffice/ChatBackOffice.tsx"

const BackOfficeRoutes = () => {
	return (
		<Route
			path={AppRoutes.backofficeHome}
			element={
				<ProtectedRoute
					authorizedProfiles={[AppAuthorizedProfiles.BACKOFFICE]}
				>
					<Outlet />
				</ProtectedRoute>
			}
		>
			<Route index element={<Navigate to={AppRoutes.backofficeChat} />} />

			<Route
				path={AppRoutes.backofficeChat}
				element={<ChatBackOffice />}
			/>
		</Route>
	)
}

export default BackOfficeRoutes
